import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI } from "../../service/http-service";
import { PaymentGatewayEndpoint } from "../../service/endpointConfig/PaymentGatewayEndpoint";

export interface PaymentGatewayResponse {
  data: any;
  message: string | undefined;
  errors: [string] | null;
}

export interface PaymentGatewayState {
  loading: boolean;
  paymentGatewayResponse: PaymentGatewayResponse;
  error: string | undefined;
}

const initialState: PaymentGatewayState = {
  loading: false,
  error: undefined,
  paymentGatewayResponse: {
    data: undefined,
    message: undefined,
    errors: null,
  },
};

export const paymentGatewayAction = createAsyncThunk(
  "master/paymentGateway",
  async (paymentGateway: any) => {
    try {
      let response;
      switch (paymentGateway.apiAction) {
        case "transactionList":
          response = await getAPI(
            PaymentGatewayEndpoint.getAllSettlementPayment
          );
          break;
        case "marketPlaceSettlementTransactions":
          response = await getAPI(
            `${PaymentGatewayEndpoint.marketPlaceSettlementTransactions}?${paymentGateway.requestParams}`
          );
          break;
        case "paymentGatewaySettlement":
          response = await getAPI(
            `${PaymentGatewayEndpoint.paymentGatewaySettlement}?${paymentGateway.requestParams}`
          );
          break;
        case "exportExcel":
          response = await postAPI(PaymentGatewayEndpoint.exportExcelTransaction, paymentGateway.formValues);
          break;
        case "importExcel":
          response = await postAPI(
            PaymentGatewayEndpoint.importExcel,
            paymentGateway.formValues
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const paymentGatewaySlice = createSlice({
  name: "paymentGateway",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.paymentGatewayResponse.data.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(paymentGatewayAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      paymentGatewayAction.fulfilled,
      (state, { payload }: any) => {
        state.loading = false;
        state.paymentGatewayResponse = payload;
      }
    );
    builder.addCase(paymentGatewayAction.rejected, (state, action) => {
      state.loading = false;
      // This is kept purposefully to check the data coming while error
      if (action.payload) {
        state.paymentGatewayResponse.data = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const paymentGatewayReducer = paymentGatewaySlice.reducer;
export default paymentGatewayReducer;
